import React from 'react';

/**
 * TaskViewTabs
 * List / Kanban / Timeline / Sprint tab switcher.
 * Dynamically filters and respects Project Step 4 Configuration:
 * Hides any views that were NOT selected in the project settings.
 */

export default function TaskViewTabs({ activeTab, onTabChange, availableViews, sprintManagement = true }) {
    const isAvailable = (key) => {
        if (key === 'sprint' && sprintManagement === false) return false;
        if (availableViews && typeof availableViews === 'object') {
            if (availableViews[key] !== undefined) return Boolean(availableViews[key]);
        }
        return true;
    };

    const ALL_TABS = [
        { key: 'list', label: 'List', available: isAvailable('list') },
        { key: 'kanban', label: 'Kanban', available: isAvailable('kanban') },
        { key: 'timeline', label: 'Timeline', available: isAvailable('timeline') },
        { key: 'sprint', label: 'Sprint', available: isAvailable('sprint') },
    ];

    // Hide any tab that was unselected/disabled in project configuration
    const visibleTabs = ALL_TABS.filter((tab) => tab.available);
    const tabsToRender = visibleTabs.length > 0 ? visibleTabs : [{ key: 'list', label: 'List', available: true }];

    return (
        <div className="flex bg-[#f3f4f5] dark:bg-[#1e293b] p-1 rounded-xl overflow-x-auto">
            {tabsToRender.map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    onClick={() => onTabChange(tab.key)}
                    className={`
                        relative px-4 sm:px-6 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap
                        ${activeTab === tab.key
                            ? 'bg-white dark:bg-[#334155] text-[#003263] dark:text-[#a7c8ff] shadow-sm font-bold'
                            : 'text-[#424750] dark:text-slate-400 hover:text-[#003263] dark:hover:text-white'
                        }
                    `}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
